import React from 'react';
import useTitle from '../useTitle';

import loadLogo from '../../load.svg';

const Project = () => {

    useTitle( "Admin Panel | Projects" );

    const [ projectData, setProjectData ] = React.useState(
        {
            title   : "",
            tags    : "",
            excerpt : "",
            github  : "",
            image   : ""
        }
    );

	const [ projectList, setProjectList ] = React.useState( [ ] );

    function fetchAPI(url,cb){

		fetch(url)
        .then( ( res ) => res.json() )
        .then( ( data ) => {
            cb(data.items);
        } )
		.catch( (e) => console.log( 'Our API service is currently offline' ) );

	}

    React.useEffect( () => {

		fetchAPI( 'https://api.subrataghosh.repl.co/api/v1/projects', setProjectList );
    
    },[]);

    const projectListElements = projectList.map( ( data ) => {
		return <tr key={data._id}>
                <td>{data._id}</td>
                <td>{data.title}</td>
                <td>{data.tags}</td>
                <td>{data.excerpt.length > 70 ? `${data.excerpt.substring(0, 70)}...` : data.excerpt}</td>
                <td>{data.github.length > 10 ? `${data.github.substring(0, 10)}...` : data.github}</td>
                <td>{data.image.length > 10 ? `${data.image.substring(0, 10)}...` : data.image}</td>
               </tr>
    });

    function handleChange( event ){

        const { name, type, value, checked } = event.target;

        setProjectData( (prevProjectData) => {

            return {
                ...prevProjectData,
                [name]: type === 'checkbox' ? checked : value
            };

        } );

    }

    function handleSubmit( event ){

        event.preventDefault();
        
        fetch( 'https://api.subrataghosh.repl.co/api/v1/project', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'multipart/form-data'
            },
            body: JSON.stringify( projectData )
          } 
        )
        .then( ( resp ) => resp.json() )
        .then( function( data ) {
			console.log( data )
			if ( data.success === 'true' ) {
            	return setProjectList( ( prevProjectList ) => { 
                    return [ ...prevProjectList, 
                        { 
                            "_id"     : data.data[0]._id,
                            "title"   : data.data[0].title,
                            "tags"    : data.data[0].tags,
                            "excerpt" : data.data[0].excerpt,
                            "github"  : data.data[0].github,
                            "image"   : data.data[0].image
                        }
                    ]; 
                } );
			} else {
				return '';
			}
        } )
		.catch( (e) => console.log( 'Failed to submit Project' ) );
    
    }

    return (
        <div>
            <h1 style={{margin:'0px'}}>Projects</h1>
            <div className="skillset-forms">
				<form onSubmit={handleSubmit}>
					<div className="skillset-forms__div2">
						<div className="skillset-forms__items">
							<p>Enter the Project Info</p>
						</div>
						<div className="skillset-forms__inputs">
							<input 
								className="input-text"
								type="text" 
								placeholder="Enter Title" 
								id="title"
								name="title"
								onChange={handleChange}
								value={projectData.title}
							/>
                            <input 
								className="input-text"
								type="text" 
								placeholder="Enter Tags" 
								id="tags"
								name="tags"
								onChange={handleChange}
								value={projectData.tags}
							/>
                            <textarea rows="2" cols="70" 
                                style={{resize: 'none'}}
								className="input-text"
								type="text" 
								placeholder="Enter Excerpt" 
								id="excerpt"
								name="excerpt"
								onChange={handleChange}
								value={projectData.excerpt}
							/>
                            <input 
								className="input-text"
								type="text" 
								placeholder="Enter Github Link" 
								id="github"
								name="github"
								onChange={handleChange}
								value={projectData.github}
							/>
                            <input 
								className="input-text"
								type="text" 
								placeholder="Enter Image" 
								id="image"
								name="image"
								onChange={handleChange}
								value={projectData.image}
							/>
						</div>
						<div className="skillset-forms__items">
							<button className="input-btn" disabled={projectData.title.length<1}>Submit</button>
						</div>
					</div>
				</form>
            </div>
            <div className="skillset-tables">
                <table border="1px solid #dddddd" style={{borderCollapse: 'collapse',width: '100%',textAlign: 'center'}}>
                    <caption>Projects</caption>
                    <tbody>
						{ projectList.length === 0 ? 
						<tr style={{display:"flex",justifyContent:"center",padding:"10%"}}>
                        	<img title="Loading Projects" src={loadLogo} alt="Loading..." style={{width:"50px"}}/>
						</tr>
                     : 
                     <>
                     <tr>
                            <th>ID</th>
                            <th>Title</th>
                            <th>Tags</th>
                            <th>Excerpt</th>
                            <th>Image</th>
                     </tr>
                     {projectListElements}
                     </> }
                    </tbody>
                </table>
            </div>
        </div>
    );

}

export default Project;